import { createPrefixer } from '@utils/router'

export const prefix = {
    admin: createPrefixer('admin'),
}
